

const validateInputPresence = (schema, inputName, inputValue, opts = {}) => {
  if (inputValue !== '') {
    return true;
  }

  if (opts.canIgnorePresenceReq === true) {
    return true;
  }

  const isRequired = 'required' in schema && schema.required.includes(inputName);
  if (!isRequired) {
    return true;
  }

  return false;
};


const validateInputPattern = (schema, inputName, inputValue, opts = {}) => {
  // For now, assume first arg is json schema.
  // Also, only one level deep.
  const maybeSchemaProp = schema.properties[inputName];
  if (typeof maybeSchemaProp === 'undefined') {
    return true;
  }

  const maybePropPattern = maybeSchemaProp.pattern;
  if (typeof maybePropPattern === 'undefined') {
    return true;
  }

  const patternRegex = new RegExp(maybePropPattern);
  return patternRegex.test(inputValue);
};


const processInputLocallyForUpdate = (schema, inputName, inputValue, opts = {}) => {
  let errors = [];
  const update = {
    [inputName]: {
      value: inputValue,
      errors
    },
  };

  if (inputValue === '') {
    const hasValidPresence = validateInputPresence(schema, inputName, inputValue, opts);
    errors = hasValidPresence ? [] : ['This field is required.'];
    update[inputName].errors = errors;
    return update;
  }

  const isValidPattern = validateInputPattern(schema, inputName, inputValue, opts);
  if (!isValidPattern) {
    errors = (opts.helperText ?
      [opts.helperText] :
      [`Incomplete or invalid ${inputName.split().join(' ')}.`]
    );
    update[inputName].errors = errors;
    return update;
  }

  // TODO: Any extra validators to be called if passed in.

  return update;
};


const initFormDataBySchema = (schema) => {
  const inputNames = Object.keys(schema.properties);

  // For now, assume only one level down.

  return inputNames.reduce((formData, inputName) => (
    Object.assign({}, formData, {
      [inputName]: {
        value: '',  // Empty string instead of undefined or null.. because React.
        errors: [],
      }
    })
  ), {});
};


const partitionFormDataByAttr = (formData) => {
  const inputNames = Object.keys(formData);
  const repacked = {formDataVal: {}, formDataErr: {}};

  return inputNames.reduce((repacked, inputName) => {
    const {value, errors} = formData[inputName];
    const formDataVal = {...repacked.formDataVal, [inputName]: value};

    const formDataErr = (errors.length === 0 ?
      repacked.formDataErr :
      {...repacked.formDataErr, [inputName]: errors}
    );
    // const formDataErr = {...repacked.formDataErr, [inputName]: errors};
    return {formDataVal, formDataErr};
  }, repacked);
};


// formDataVal should always be a single level kv {inputName: inputValue} object.
const compactFormDataVal = (formDataVal) => {
  const inputNames = Object.keys(formDataVal);

  const formDataValCompact = inputNames.reduce((compacted, inputName) => {
    const inputValue = formDataVal[inputName];
    if (typeof inputValue === 'string' && !inputValue.trim()) {
      return compacted;
    }

    return {...compacted, [inputName]: inputValue};
  }, {});

  return formDataValCompact;
};


export {
  validateInputPresence,
  validateInputPattern,
  processInputLocallyForUpdate,
  initFormDataBySchema,
  partitionFormDataByAttr,
  compactFormDataVal,
};



// WEBPACK FOOTER //
// ./src/helpers/formHelper.js